import TemplateResolver from 'resolvers/RTMResolvers/TemplateResolver';
import {
  ListTemplatesFromMockData,
  getTemplateCategories,
} from 'services/TemplateService/helpers/templateListHelpers';

import { sectionCategories, sectionTemplates } from './mock/cornucopiaTemplates';

export default (() => {
  /**
   * @type {TemplateResolver}
   */
  let templateResolver;
  let isRegistered = false;

  /**
   * Creates a template
   *   [RTM Docs](https://unsightly-rock.cloudvent.net/messages/author-template-create/)
   * @param {string} workspaceId
   * @param {string} templateType
   * @param {array} categories
   * @param {string} config
   * @param {string} description
   * @param {string} name
   * @param {string} thumbnail
   * @param {string} pluginId
   * @param {string} metadata
   * 
   * @returns {Promise.<[TemplateDto]>}
   */
  const authorTemplateCreate = async ({
    workspaceId,
    templateType,
    categories,
    config,
    description,
    name,
    thumbnail,
    pluginId,
    metadata,
  }) => {
    try {
      const template = await templateResolver.authorTemplateCreate({
        workspaceId,
        templateType,
        categories,
        config,
        description,
        name,
        thumbnail,
        pluginId,
        metadata,
      });
      return template;
    } catch (error) {
      throw new Error(`error occured while creating template: , ${error}.`);
    } 
  };

  /**
   * Updates a template
   *   [RTM Docs](https://unsightly-rock.cloudvent.net/messages/author-template-update/)
   * @param {string} templateId
   * @param {string} templateType
   * @param {array} categories
   * @param {string} config
   * @param {string} description
   * @param {string} name
   * @param {string} thumbnail
   * @param {string} pluginId
   * @param {string} metadata
   * 
   * @returns {Promise.<[TemplateDto]>}
   */
  const authorTemplateUpdate = async ({
    templateId,
    templateType,
    categories,
    config,
    description,
    name,
    thumbnail,
    pluginId,
    metadata,
  }) => {
    try {
      const template = await templateResolver.authorTemplateUpdate({
        templateId,
        templateType,
        categories,
        config,
        description,
        name,
        thumbnail,
        pluginId,
        metadata,
      });
      return template;
    } catch (error) {
      throw new Error(`error occured while updating template: , ${error}.`);
    } 
  };
  
  /**
   * Get list of all templates
   *   [RTM Docs](https://unsightly-rock.cloudvent.net/messages/author-template-list/)
   * 
   * @returns {Promise.<[TemplateDto]>}
   */
  const authorTemplateList = async () => {
    try {
      const templates = await templateResolver.authorTemplateList();
      return templates;
    } catch (error) {
      throw new Error(`error occured while fetching templates: , ${error}.`);
    }
  };


  /**
   * Get a template by templateId
   *   [RTM Docs](https://unsightly-rock.cloudvent.net/messages/author-template-get)
   * @param {string} templateId
   * 
   * @returns {Promise.<TemplateDto>}
   */
  const authorTemplateGet = async (templateId) => {
    try {
      const template = await templateResolver.authorTemplateGet(templateId);
      return template;
    } catch (error) {
      throw new Error(`error occured while fetching a template: , ${error}.`);
    }
  };

  /**
   * Filter the templates by type 
   *   [RTM Docs](https://unsightly-rock.cloudvent.net/messages/author-templates-filter-type/)
   * @param {string} templateType
   * 
   * @returns {Promise.<[TemplateDto]>}
   */
  const authorTemplatesFilterType = async (templateType) => {
    try {
      const templates = await templateResolver.authorTemplatesFilterType(templateType);
      return templates;
    } catch (error) {
      throw new Error(`error occured while filtering templates by type: , ${error}.`);
    }
  };

  /**  
   * Delete template(s) by its templateId
   *   [RTM Docs](https://unsightly-rock.cloudvent.net/messages/author-template-delete)
   * @param {Array<string>} templateIds
   * 
   * @returns {Promise.<void>}
   */

  const authorTemplateDelete = async (templateIds) => {
    try {
      await templateResolver.authorTemplateDelete(templateIds);
    } catch (error) {
      throw new Error(`error occured while deleting a template: , ${error}.`);
    }
  };

  /**
   * TODO: This will change to an RTM call to fetch templates
   * from BE once the template api is completed - also remove 
   * 'cornucopia' and change to getTemplates
   * @param {string} templateType 
   * @returns Array<Template>
   */
  const getCornucopiaTemplates = (templateType) => {
    switch(templateType) {
      case 'section':
      default:
        return sectionTemplates;
    }
  };

  /**
   * TODO: This will change to an RTM call to fetch templates
   * from BE once the template api is completed - also remove 
   * 'cornucopia' and change to getTemplateCategories
   * @param {string} templateType 
   * @returns Array<string>
   */
  const getCornucopiaCategories = (templateType) => {
    switch(templateType) {
      case 'section':
      default:
        return sectionCategories;
    }
  };

  /**
   * Get list of all templates
   *   [RTM Docs](https://unsightly-rock.cloudvent.net/messages/author-templates-filter)
   * 
   * @param {string} templateType 
   * @param {string} category 
   * @returns {Promise.<[TemplateDto]>}
   */
  const authorTemplatesFilter = async (templateType, category) => {
    try {
      const templates = await templateResolver.authorTemplatesFilter(templateType, category);
      return templates;
    } catch (error) {
      throw new Error(`error occurred while fetching the templates: , ${error}.`);
    }
  };

  return {
    isRegistered: () => isRegistered,
    register: (connectionProvider) => {
      isRegistered = true;
      templateResolver = new TemplateResolver(connectionProvider);
    },

    authorTemplateCreate,
    authorTemplateUpdate,
    authorTemplateList,
    authorTemplateGet,
    authorTemplatesFilter,
    authorTemplatesFilterType,
    authorTemplateDelete,
    
    getTemplates: ListTemplatesFromMockData,
    getTemplateCategories,
    getCornucopiaCategories,
    getCornucopiaTemplates,
  };
})();
